import { Button } from '@/components/ui/button';
import { Video, Radio, Users } from 'lucide-react';

interface ContentTabsProps {
  mode: 'lite' | 'full';
  selectedType: 'posts' | 'casts' | 'my_teams';
  onTypeChange: (type: 'posts' | 'casts' | 'my_teams') => void;
}

export const ContentTabs = ({ 
  mode,
  selectedType, 
  onTypeChange 
}: ContentTabsProps) => {
  const height = 'h-6'; // Reduced to 24px for compact density
  const wrap = mode === 'lite' ? 'mt-1' : 'mt-1'; // Reduced gap
  
  return (
    <div className={`${wrap} grid grid-cols-3 gap-2`} role="tablist" aria-label="Content type">
      <Button
        variant="ghost"
        onClick={() => onTypeChange('posts')}
        role="tab"
        aria-selected={selectedType === 'posts'}
        tabIndex={selectedType === 'posts' ? 0 : -1}
        className={`${height} text-xs sm:text-sm px-3 py-0 rounded-xl ${
          selectedType === 'posts'
            ? 'bg-orange-600 text-white shadow-sm hover:bg-orange-700 active:bg-orange-800 focus:outline-none focus:ring-2 focus:ring-orange-300' 
            : 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300'
        }`}
      >
        <Video className="h-3 w-3 mr-1" />
        <span className="hidden xs:inline">Posts</span>
        <span className="xs:hidden">📹</span>
      </Button>
      
      <Button
        variant="ghost"
        onClick={() => onTypeChange('casts')}
        role="tab"
        aria-selected={selectedType === 'casts'}
        tabIndex={selectedType === 'casts' ? 0 : -1}
        className={`${height} text-xs sm:text-sm px-3 py-0 rounded-xl ${
          selectedType === 'casts' 
            ? 'bg-violet-600 text-white shadow-sm hover:bg-violet-700 active:bg-violet-800 focus:outline-none focus:ring-2 focus:ring-violet-300' 
            : 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300'
        }`}
      >
        <Radio className="h-3 w-3 mr-1" />
        <span className="hidden xs:inline">ISO Casts</span>
        <span className="xs:hidden">📡</span>
      </Button>
      
      <Button
        variant="ghost"
        onClick={() => onTypeChange('my_teams')}
        role="tab"
        aria-selected={selectedType === 'my_teams'}
        tabIndex={selectedType === 'my_teams' ? 0 : -1}
        className={`${height} text-xs sm:text-sm px-3 py-0 rounded-xl ${
          selectedType === 'my_teams' 
            ? 'bg-emerald-700 text-white shadow-sm hover:bg-emerald-800 active:bg-emerald-900 focus:outline-none focus:ring-2 focus:ring-emerald-300' 
            : 'border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300'
        }`}
      >
        <Users className="h-3 w-3 mr-1" />
        <span className="hidden xs:inline">My Teams</span>
        <span className="xs:hidden">👥</span>
      </Button>
    </div>
  );
};
